document.addEventListener("DOMContentLoaded", function () {
  // ==== helpers ==============================================================
  function validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  // very light E.164-ish validation (7–15 digits, optional leading +)
  function validatePhone(phone) {
    if (!phone) return false;
    const cleaned = phone.trim();
    return /^\+?[1-9]\d{6,14}$/.test(cleaned);
  }

  // Map Shopify variant ID -> Klaviyo catalog-variant ID
  function toKlaviyoVariantId(shopifyVariantId) {
    return `$shopify:::$default:::${shopifyVariantId}`;
  }

  function showMessage(node, text) {
    if (!node) return;
    node.innerHTML = text;
    node.style.display = "block";
  }

  // ==== config ===============================================================
  // Your Klaviyo PUBLIC key (site ID). Safe to expose on client.
  const KLAVIYO_PUBLIC_KEY = "H5cQT5";

  // Optional: what to do after a successful submit (analytics, close modal, etc.)
  function afterSubmitSuccess({ email, phone, variantId, productId }) {
    // 1) Fire a CustomEvent (so other scripts can listen)
    document.dispatchEvent(
      new CustomEvent("bis:subscribed", {
        detail: { email, phone, variantId, productId, ts: Date.now() },
      })
    );

    // 2) Push to dataLayer (if GTM present)
    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "bis_subscribed",
        bis_email: email || null,
        bis_phone: phone || null,
        bis_variant_id: variantId,
        bis_product_id: productId || null,
      });
    }

    // 3) Optional callback hook if you want to run custom logic outside this file
    if (typeof window.onBISubscribe === "function") {
      try {
        window.onBISubscribe({ email, phone, variantId, productId });
      } catch (_) {}
    }
  }

  // ==== DOM hooks ============================================================
  const bisForm = document.querySelector(".waitlist-popup--bis");
  const message = document.querySelector(".bis--message");

  if (!bisForm) return;

  bisForm.addEventListener("submit", function (e) {
    e.preventDefault();

    const emailInput = document.getElementById("bis--input");     // email
    const phoneInput = document.getElementById("bis--phone");     // phone (new)
    const smsConsent = document.getElementById("bis--sms-consent"); // optional checkbox
    const variantInput = document.getElementById("bis--id");      // shopify variant id
    const productIdField =
      document.querySelector('input[name="product-id"]') || null;

    const email = emailInput ? emailInput.value.trim() : "";
    const phone = phoneInput ? phoneInput.value.trim() : "";
    const variantIdRaw = variantInput ? variantInput.value.trim() : "";
    const productId = productIdField ? productIdField.value : window.productId;

    // Basic validation
    if (!email && !phone) {
      showMessage(message, "Please enter an email address or a phone number.");
      return;
    }
    if (email && !validateEmail(email)) {
      showMessage(message, "Please enter a valid email address.");
      return;
    }
    if (phone && !validatePhone(phone)) {
      showMessage(
        message,
        "Please enter a valid phone number (include country code, e.g. +12025550123)."
      );
      return;
    }
    if (!variantIdRaw) {
      showMessage(message, "Missing variant ID.");
      return;
    }

    // Build channels based on what the user provided
    const channels = [];
    if (email) channels.push("EMAIL");
    if (phone) {
      // If you show an SMS consent checkbox, require it for SMS channel
      if (smsConsent && !smsConsent.checked) {
        showMessage(
          message,
          "Please check the box to consent to SMS notifications, or remove your phone number."
        );
        return;
      }
      channels.push("SMS");
    }

    // Construct Klaviyo profile attributes
    const profileAttributes = {};
    if (email) profileAttributes.email = email;
    if (phone) profileAttributes.phone_number = phone;

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: profileAttributes,
            },
          },
          channels, // ["EMAIL"], ["SMS"], or both
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: toKlaviyoVariantId(variantIdRaw),
            },
          },
        },
      },
    };

    const url =
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?" +
      "company_id=" +
      encodeURIComponent(KLAVIYO_PUBLIC_KEY);

    // UI state: disable submit button to prevent double submits
    const submitBtn =
      bisForm.querySelector('[type="submit"]') ||
      bisForm.querySelector("button");
    if (submitBtn) submitBtn.disabled = true;

    fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-store",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        // If this header ever causes CORS preflight issues in your setup, remove it.
        Revision: "2025-04-15",
      },
      body: JSON.stringify(payload),
      credentials: "omit",
    })
      .then(async (res) => {
        const text = await res.text();
        let data;
        try {
          data = text ? JSON.parse(text) : {};
        } catch {
          data = { raw: text };
        }

        if (!res.ok) {
          const detail =
            data?.errors?.[0]?.detail ||
            data?.message ||
            res.statusText ||
            "Request failed.";
          throw new Error(detail);
        }
        return data;
      })
      .then(() => {
        showMessage(
          message,
          "You're in! We'll let you know when it's back."
        );

        // Optional: clear inputs
        if (emailInput) emailInput.value = "";
        if (phoneInput) phoneInput.value = "";
        if (smsConsent) smsConsent.checked = false;

        // Optional: visually lock the form, or hide it
        bisForm.classList.add("bis--submitted");
        // Example: hide form after success
        // bisForm.style.display = "none";

        // Fire analytics / callbacks
        afterSubmitSuccess({
          email: email || null,
          phone: phone || null,
          variantId: variantIdRaw,
          productId: productId || null,
        });
      })
      .catch((err) => {
        console.error("Klaviyo BIS error:", err);
        showMessage(
          message,
          "Sorry—something went wrong. Please try again."
        );
      })
      .finally(() => {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
});